module.exports = __webpack_public_path__ + "img/08—01—04—Diagnostic information > Telephony.1ed04c9d.jpg";